import apiClient from './client';

export const getHonorBalance = () =>
  apiClient.get('/api/honor/balance').then(res => res.data);

export const getHonorHistory = (limit = 50) =>
  apiClient.get('/api/honor/history', { params: { limit } }).then(res => res.data);
